module.exports = __webpack_public_path__ + "static/media/h320_6.16f92cc85d7261204cf14a05701f5a5b.png";